import script from "./City.vue?vue&type=script&setup=true&lang=js"
export * from "./City.vue?vue&type=script&setup=true&lang=js"

import "./City.vue?vue&type=style&index=0&id=52f5aa96&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f5aa96"]])

export default __exports__